interface NumPadProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  maxLength?: number;
  masked?: boolean;
  placeholder?: string;
}

const KEYS = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
  ['C', '0', 'OK'],
] as const;

export function NumPad({
  value,
  onChange,
  onSubmit,
  maxLength = 20,
  masked = false,
  placeholder = '',
}: NumPadProps) {
  const displayValue = masked
    ? '\u2022'.repeat(value.length)
    : value;

  function handleKey(key: string) {
    if (key === 'C') {
      onChange('');
      return;
    }
    if (key === 'OK') {
      onSubmit();
      return;
    }
    if (value.length < maxLength) {
      onChange(value + key);
    }
  }

  return (
    <div className="flex flex-col gap-4 w-full max-w-[340px] mx-auto">
      {/* Display */}
      <div className="bg-surface rounded-xl px-6 py-4 min-h-[56px] flex items-center justify-center">
        {value.length > 0 ? (
          <span className="text-2xl font-bold text-white tracking-widest">
            {displayValue}
          </span>
        ) : (
          <span className="text-xl text-white/30">{placeholder}</span>
        )}
      </div>

      {/* Keypad grid */}
      <div className="grid grid-cols-3 gap-3">
        {KEYS.flat().map((key) => {
          const isClear = key === 'C';
          const isSubmit = key === 'OK';

          let className =
            'bg-surface-light rounded-xl min-h-[64px] text-2xl font-semibold transition-all duration-150 active:bg-surface-card active:scale-95 flex items-center justify-center';

          if (isClear) {
            className += ' text-danger';
          } else if (isSubmit) {
            className += ' text-success bg-success/20';
          } else {
            className += ' text-white';
          }

          return (
            <button
              key={key}
              type="button"
              className={className}
              onClick={() => handleKey(key)}
            >
              {isSubmit ? (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" className="text-success">
                  <path
                    d="M5 12l5 5L19 7"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                key
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
